export type LanguageName =
  | 'Arabic'
  | 'Bulgarian'
  | 'Czech'
  | 'Croatian'
  | 'Greek'
  | 'Hebrew'
  | 'Chinese (Simplified)'
  | 'Danish'
  | 'Dutch'
  | 'English'
  | 'Estonian'
  | 'Finnish'
  | 'French'
  | 'German'
  | 'Italian'
  | 'Japanese'
  | 'Korean'
  | 'Latvian'
  | 'Lithuanian'
  | 'Norwegian'
  | 'Polish'
  | 'Portuguese'
  | 'Russian'
  | 'Spanish'
  | 'Swedish'
  | 'Slovenian'
  | 'Slovakian'
  | 'Ukrainian'
  | 'Thai'
  | 'Turkish'
  | 'Icelandic'
  | 'Hungarian'
  | 'Romanian';

export type LanguageCode =
  | 'en'
  | 'bg'
  | 'cs'
  | 'hr'
  | 'el'
  | 'he'
  | 'uk'
  | 'da'
  | 'nl'
  | 'et'
  | 'fi'
  | 'fr'
  | 'de'
  | 'it'
  | 'lt'
  | 'lv'
  | 'no'
  | 'pl'
  | 'pt'
  | 'ru'
  | 'es'
  | 'sv'
  | 'ar'
  | 'zh'
  | 'ja'
  | 'ko'
  | 'th'
  | 'tr'
  | 'sl'
  | 'sk'
  | 'is'
  | 'hu'
  | 'ro';

export type Language = { label: LanguageName; code: LanguageCode };

export const DEFAULT_LANG_CODE = 'en' as const;

// The `code` field contains a language code as per BCP-37 specifications (https://tools.ietf.org/rfc/bcp/bcp47.txt).
export const languages: Language[] = [
  { label: 'English', code: 'en' },
  { label: 'Bulgarian', code: 'bg' },
  { label: 'Czech', code: 'cs' },
  { label: 'Croatian', code: 'hr' },
  { label: 'Greek', code: 'el' },
  { label: 'Hebrew', code: 'he' },
  { label: 'Slovenian', code: 'sl' },
  { label: 'Slovakian', code: 'sk' },
  { label: 'Danish', code: 'da' },
  { label: 'Dutch', code: 'nl' },
  { label: 'Estonian', code: 'et' },
  { label: 'Finnish', code: 'fi' },
  { label: 'French', code: 'fr' },
  { label: 'German', code: 'de' },
  { label: 'Italian', code: 'it' },
  { label: 'Lithuanian', code: 'lt' },
  { label: 'Latvian', code: 'lv' },
  { label: 'Norwegian', code: 'no' },
  { label: 'Polish', code: 'pl' },
  { label: 'Portuguese', code: 'pt' },
  { label: 'Russian', code: 'ru' },
  { label: 'Spanish', code: 'es' },
  { label: 'Swedish', code: 'sv' },
  { label: 'Arabic', code: 'ar' },
  { label: 'Chinese (Simplified)', code: 'zh' },
  { label: 'Japanese', code: 'ja' },
  { label: 'Korean', code: 'ko' },
  { label: 'Thai', code: 'th' },
  { label: 'Turkish', code: 'tr' },
  { label: 'Icelandic', code: 'is' },
  { label: 'Hungarian', code: 'hu' },
  { label: 'Romanian', code: 'ro' },
  { label: 'Ukrainian', code: 'uk' },
];

// make sure the list stays sorted regardless of the order in which they are added
languages.sort(({ label: labelA }, { label: labelB }) => {
  const nameA = labelA.toLowerCase();
  const nameB = labelB.toLowerCase();
  return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
});

export function findLabelByLanguageCode(
  code: LanguageCode,
): LanguageName | undefined {
  const language = languages.find((l) => l.code === code);
  return language?.label;
}

export default languages;
